module.exports = __webpack_public_path__ + "img/Virtual_Brand_Presenter.d20bf5ad.jpg";